import PageSeo from '@/components/PageSeo';
import ShittyMap from '@/components/ShittyMap';
import PageHeader from '../../components/PageHeader';

export default function ShittyMapPage() {
  return (
    <div className='min-h-screen'>
      <PageSeo
        title='Shitty Map - Explore All 500 Cities'
        description='Interactive visualization of all 500 Shitty Cities. Explore the world, filter by upgrades, and discover every city in the collection.'
      />

      <PageHeader heading='Shitty Map' description='Explore all 500 Shitty Cities in one interactive world map.' className='mb-0 pb-4' />

      <div className='py-6 px-4'>
        <ShittyMap />
      </div>
    </div>
  );
}
